import { Account, AccountRequestWithTrial } from '../../../@types/Account';

/**
 * Shift date by number of days, for example:
 * 1/1/2022 + 3 days = 4/1/2022
 * @param date Date object or a date formatted string
 * @param daysToAdd total number of days to add to the date
 * @returns new date object shifted by `daysToAdd`
 */
export const addDays = (date: Date | string, daysToAdd: number): Date => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + daysToAdd);

  return newDate;
};

export const getInitialState = (account: Account | null, totalCredits:number, creditsUsed: number): AccountRequestWithTrial => {
  return {
    displayName: account?.displayName || '',
    accountStatus: account?.accountStatus || 'ACTIVE',
    companyInfo: {
      id: account?.companyInfo?.id || '',
      city: account?.companyInfo?.city || '',
      state: account?.companyInfo?.state || '',
      country: account?.companyInfo?.country || '',
      name: account?.companyInfo?.name || '',
      size: account?.companyInfo?.size || 'SMALL',
      isManual: account?.companyInfo?.isManual || false,
      linkedinUrl: account?.companyInfo?.linkedinUrl || '',
    },
    subDomainName: account?.subDomainName || account?.displayName || '',
    logo: account?.logo || '',
    startDatePaidPlan: account?.plan?.startDate || '',
    endDatePaidPlan: account?.plan?.endDate || '',
    pricingPlan: account?.plan?.planDefinition?.pricingPlan,
    billing: account?.plan?.billingCycle,
    accountPlanDefinitionId: account?.plan?.planDefinition.id || '',
    maximumOpenPositions: account?.plan.maximumOpenPositions || 0,
    maxUserSeats: account?.plan?.maxUserSeats ?? 0,
    userSeatsPlanLimit: account?.plan?.planDefinition?.userSeatsPlanLimit ?? null,
    creditsUsed: creditsUsed ?? 0,
    totalCredits: totalCredits ?? 0,
    isCreditsBased: (account?.plan?.isCreditsBased ?? false).toString(),
    addCredits: 0,
    recruitingUsageType: account?.recruitingUsageType,
    outreachEnabledForTrial: account?.outreachEnabledForTrial ?? false,
  };
};
